var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',{staticStyle:{"height":"100vh"}},[_c('side-menu',{attrs:{"menu-list":_vm.menuRoutes}}),_c('el-main',[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }